import { Component, Input, OnInit } from '@angular/core';

import { UmsService } from '../ums.service';

import { NgxSpinnerService } from 'ngx-spinner';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { AlertBoxComponent } from '../alert-box/alert-box.component';

import { ModalpopService } from '../modalpop.service';

import { HttpErrorResponse } from '@angular/common/http';

import { MatDialogRef } from '@angular/material/dialog';

import { saveAs } from 'file-saver';

import { Location } from '@angular/common';

@Component({

  selector: 'app-reports',

  templateUrl: './reports.component.html',

  styleUrls: ['./reports.component.scss']

})

export class ReportsComponent implements OnInit {

  receivedData: string;

  dialogRef: MatDialogRef<any>;
  constructor(public umsService: UmsService, private location: Location,
    private spinner: NgxSpinnerService, private modalPopupService: ModalpopService,) { }

  ngOnInit(): void {
    this.renderReport();
  }
  renderReport() {
    this.receivedData = JSON.parse(this.umsService.getData());
    var payload = this.receivedData;
    this.spinner.show();
    this.umsService.SetReportParam(payload).subscribe(res => {
      this.spinner.hide();

      if (res.status) {
        this.Report();

      }
      else {
        // this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }

    }
      , (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      });


  }

  Report() {
    // this.spinner.show();
    this.showIframeSpinner();
    var payload: any;
    payload = {
      "reportPath": "~/Reports/UMS",
      "exportFilename": "Report.pdf",
      "filter": {
        "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      //  "DBName": "EDPS_MUHS_V4_PRODCOPY" //UAT
        "DBName": "EDPS_MUHS_V2"  // Prod
      }
    };
    this.umsService.renderReport(payload).subscribe(
      (res: Blob) => {
        // this.spinner.hide();
        if (res.type == "application/csv") {
          // this.spinner.hide();
          this.hideIframeSpinner();
          saveAs(res, 'report.csv');
        } else {
          // this.spinner.hide();
          let iframe = document.querySelector("iframe");
          iframe.src = URL.createObjectURL(res);
          iframe.addEventListener('load', this.onIframeLoad);
        }
      },
      (error) => {
        // this.spinner.hide();
        this.hideIframeSpinner();
      }
    );
    // this.umsService.renderReport(payload).subscribe(res => {
    //   // var iframe = document.querySelector("iframe");


    //   // iframe.src = URL.createObjectURL(res);
    //   });
  }

  onIframeLoad() {
    this.hideIframeSpinner();
    // this.spinner.hide();
  }

  private showIframeSpinner() {
    let iframe = document.querySelector("iframe") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage('showSpinner', '*');
    }
  }

  // Method to hide spinner in the iframe
  private hideIframeSpinner() {
    let iframe = document.querySelector("iframe") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage('hideSpinner', '*');
    }
  }

  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }
}